import { render } from "./UserCreateEdit.vue?vue&type=template&id=6c05ca14&scoped=true"
import script from "./UserCreateEdit.vue?vue&type=script&lang=js"
export * from "./UserCreateEdit.vue?vue&type=script&lang=js"

import "./UserCreateEdit.vue?vue&type=style&index=0&id=6c05ca14&lang=scss&scoped=true"
import "./UserCreateEdit.vue?vue&type=style&index=1&id=6c05ca14&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c05ca14"]])

export default __exports__